import { ThemeTypography } from './ThemeTypography';

export const AppErrorMessage = () => (
  <ThemeTypography type="heading3">
    Vår applikation kunde inte hantera detta scenario.
  </ThemeTypography>
);
